import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const server: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M1-1h8v-1H1Zm0-4h8v-1H1ZM13.031-.969a.72.72 0 0 0 .219-.531.74.74 0 0 0-.219-.531.74.74 0 0 0-.531-.219.72.72 0 0 0-.531.219.72.72 0 0 0-.219.531c0 .211.07.387.219.531.144.149.32.219.531.219a.72.72 0 0 0 .531-.219M1-9h8v-1H1Zm12.031 4.031a.72.72 0 0 0 .219-.531.74.74 0 0 0-.219-.531.74.74 0 0 0-.531-.219.72.72 0 0 0-.531.219.72.72 0 0 0-.219.531c0 .211.07.387.219.531.144.149.32.219.531.219a.72.72 0 0 0 .531-.219m0-4a.72.72 0 0 0 .219-.531.74.74 0 0 0-.219-.531.74.74 0 0 0-.531-.219.72.72 0 0 0-.531.219.72.72 0 0 0-.219.531c0 .211.07.387.219.531.144.149.32.219.531.219a.72.72 0 0 0 .531-.219M14-3v3H0v-3Zm0-4v3H0v-3zm0-4v3H0v-3zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "14",
  }
};
